/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_Col_RestoreInputs */

const vi_confirm_return_col_restore = /** @type {(inputs: Confirm_Return_Col_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NHẬP LẠI`)
};

/**

* @param {Confirm_Return_Col_RestoreInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_col_restore = /** @type {((inputs?: Confirm_Return_Col_RestoreInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_Col_RestoreInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_col_restore(inputs)
});